class BSO_BULK_PRICES_WRAPPER extends HTMLElement {
  constructor() {
    super();

    this.config = JSON.parse(this.getAttribute('data-bulk-prices-config') || null);
    this.bulkprices = this.querySelectorAll('bso-bulk-price');

    this.quantitys = [];
    if (this.config) {
      this.quantitys = this.config.map((item) => item.amount);
    }
  }

  connectedCallback() {
    document.addEventListener('quantity:changed', this.selectBulkPrice.bind(this));

    for (const bulkprice of this.bulkprices) {
      bulkprice.addEventListener('click', this.onClickHandler.bind(this));
    }
  }

  onClickHandler(e) {
    const quantityInput = document.querySelector('.product product-form .qty-input__input');
    if (!quantityInput) return;

    const amount = e.target.closest('bso-bulk-price').getAttribute('data-amount');

    for (const bulkprice of this.bulkprices) {
      bulkprice.classList.remove('discount-active');
    }
    
    e.target.closest('bso-bulk-price').classList.toggle('discount-active');
    quantityInput.value = amount;

    const customEvent = new CustomEvent('quantity:changed:bulk:button', { bubbles: true, detail: amount });
    this.dispatchEvent(customEvent);
  }

  selectBulkPrice(e) {
    const inputQuantity = Number(e.detail);
    const quantitys = this.quantitys.sort((a, b) => a - b).reverse();

    for (const bulkprice of this.bulkprices) {
      bulkprice.classList.remove('discount-active');
    }

    for (const quantity of quantitys) {
      if (inputQuantity >= quantity) {
        this.querySelector(`bso-bulk-price[data-amount="${quantity}"]`).classList.toggle('discount-active');
        break
      }
    }
  }
}

customElements.define('bso-bulk-prices-wrapper', BSO_BULK_PRICES_WRAPPER);
